import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
// import Iconify from 'src/components/iconify';



// ----------------------------------------------------------------------

export default function DashPlansTableRow({ row, }) {
  const {  date, planName, amount, paymentMode, status, invoice, } = row;

  return (
    <>
      <TableRow hover >
        <TableCell sx={{ whiteSpace: 'nowrap', fontWeight:600 }}>{ date}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap', fontWeight:600 }}>{ planName}</TableCell>


        <TableCell sx={{ whiteSpace: 'nowrap', fontWeight:600 }}>{amount}</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap', fontWeight:600 }}>{paymentMode }</TableCell>
        <TableCell sx={{ whiteSpace: 'nowrap', fontWeight:600 }}>{status  } &nbsp;<span style={{ color:'blue'}}> { invoice}</span></TableCell>


      </TableRow>





    </>
  );
}

DashPlansTableRow.propTypes = {
  row: PropTypes.object,
};
